var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-template-card" },
    [
      _c(
        "header",
        { staticClass: "automation-template-card__header" },
        [
          _vm.isLoading
            ? [
                _c(
                  "div",
                  { staticClass: "automation-template-card__header-skeleton" },
                  _vm._l(3, function(skeleton) {
                    return _c("CompassSkeleton", {
                      key: skeleton,
                      attrs: { variant: "square" }
                    })
                  }),
                  1
                )
              ]
            : [
                _c(
                  "div",
                  { staticClass: "automation-template-card__header-content" },
                  [
                    _c("AutomationPieces", {
                      attrs: { pieces: _vm.template.pieces }
                    }),
                    _vm._v(" "),
                    _vm.template.isPopular
                      ? _c(
                          "CompassTooltip",
                          {
                            staticClass:
                              "automation-template-card__tag-tooltip",
                            attrs: {
                              content: _vm.translations.popular,
                              arrow: false
                            }
                          },
                          [
                            _c(
                              "CompassTag",
                              {
                                staticClass: "automation-template-card__tag",
                                attrs: { color: "yellow", size: "small" }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.translations.labelFlag) +
                                    "\n                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.isLoading
        ? [
            _c("CompassSkeleton", {
              staticClass: "automation-template-card__skeleton-half"
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "automation-template-card__content-skeleton" },
              _vm._l(2, function(skeleton) {
                return _c("CompassSkeleton", { key: skeleton })
              }),
              1
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "automation-template-card__content" },
              [
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      content: _vm.template.title,
                      arrow: false,
                      disabled: !_vm.isTitleTruncated,
                      delay: { show: 1000, hide: 0 }
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        ref: "titleElement",
                        staticClass:
                          "automation-template-card__title typographies-paragraph-medium-semibold",
                        on: { mouseenter: _vm.checkTitleTruncation }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.template.title) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      content: _vm.template.description,
                      arrow: false,
                      disabled: !_vm.isDescriptionTruncated,
                      delay: { show: 1000, hide: 0 }
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        ref: "descriptionElement",
                        staticClass:
                          "automation-template-card__description typographies-paragraph-medium-regular",
                        on: { mouseenter: _vm.checkDescriptionTruncation }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.template.description) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "automation-template-card__footer" },
        [
          _vm.isLoading
            ? [
                _c("CompassSkeleton", {
                  staticClass: "automation-template-card__skeleton-half"
                })
              ]
            : [
                _c("CompassButton", {
                  staticClass: "automation-template-card__use-template-button",
                  attrs: {
                    label: _vm.translations.useTemplate,
                    type: "tertiary",
                    loading: _vm.isLoading
                  },
                  on: { click: _vm.handleCreateAutomationWithTemplate }
                })
              ]
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }